// active-recipe-process-groups.ts
//
// Codex review CXR-01 (2026-10-01): verification/deploy recipes run in their
// own process group (`detached`) so a timeout can stop the whole tree. A
// detached group no longer receives the terminal's Ctrl-C, so the `run`
// interrupt handler (run-interrupt-signal-handler.ts) reads this registry to
// forward its TERM/KILL to every recipe still running — what a foreground
// child used to get from the terminal for free.
const groups = new Set<number>();

export function registerRecipeProcessGroup(pgid: number): void {
  groups.add(pgid);
}

export function unregisterRecipeProcessGroup(pgid: number): void {
  groups.delete(pgid);
}

/** Process-group ids of recipes currently running in this process. */
export function activeRecipeProcessGroups(): number[] {
  return [...groups];
}
